import { render, staticRenderFns } from "./CreateEquivalence.vue?vue&type=template&id=451e5732&scoped=true&"
import script from "./CreateEquivalence.vue?vue&type=script&lang=ts&"
export * from "./CreateEquivalence.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEquivalence.vue?vue&type=style&index=0&id=451e5732&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451e5732",
  null
  
)

export default component.exports